/* Spanish (Spain, International Sort) locale settings for Webix */
webix.i18n.locales['tr-TR'] = {
    groupDelimiter: '.', // Delimiter for groups of thousands
    groupSize: 3, // Size of groups of thousands
    decimalDelimiter: ',', // Delimiter for decimal part
    decimalSize: 2, // Number of decimal places
    dateFormat: '%d/%n/%Y', // Date format
    timeFormat: '%G:%i', // Time format
    longDateFormat: '%d %F %Y', // Long date format
    fullDateFormat: '%d %F %Y %G:%i', // Full date and time format
    am: null, // AM marker (not used in this locale)
    pm: null, // PM marker (not used in this locale)
    price: '{obj} €', // Price format
    priceSettings: {
        groupDelimiter: '.', // Delimiter for groups of thousands in prices
        groupSize: 3, // Size of groups of thousands in prices
        decimalDelimiter: ',', // Delimiter for decimal part in prices
        decimalSize: 2, // Number of decimal places in prices
    },
    calendar: {
        monthFull: [
            'Ocak',
            'Şubat',
            'Mart',
            'Nisan',
            'Mayıs',
            'Haziran',
            'Temmuz',
            'Ağustos',
            'Eylül',
            'Ekim',
            'Kasım',
            'Aralık',
        ], // Full names of months
        monthShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'], // Short names of months
        dayFull: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'], // Full names of days
        dayShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'], // Short names of days
        hours: 'Saat', // Label for hours
        minutes: 'Dakika', // Label for minutes
        done: 'Tamam', // Label for done button
        clear: 'Sıfırla', // Label for clear button
        today: 'Bugün', // Label for today button
    },
    dataExport: {
        page: 'Sayfa', // Label for page
        of: ' / ', // Label for of (Turkish often uses " / " or " / " for page X of Y)
    },
    PDFviewer: {
        of: ' / ', // Label for of
        automaticZoom: 'Otomatik yakınlaştır', // Label for automatic zoom
        actualSize: 'Gerçek boyut', // Label for actual size
        pageFit: 'Sayfa boyutu', // Label for page fit
        pageWidth: 'Sayfa genişliği', // Label for page width
        pageHeight: 'Sayfa yüksekliği', // Label for page height
    },
    aria: {
        calendar: 'Takvim', // ARIA label for calendar
        increaseValue: 'Değeri artır', // ARIA label for increase value
        decreaseValue: 'Değeri azalt', // ARIA label for decrease value
        navMonth: ['Önceki ay', 'Sonraki ay'], // ARIA labels for navigating months
        navYear: ['Önceki yıl', 'Sonraki yıl'], // ARIA labels for navigating years
        navDecade: ['Önceki on yıl', 'Sonraki on yıl'], // ARIA labels for navigating decades
        dateFormat: '%d %F %Y', // ARIA date format
        monthFormat: '%F %Y', // ARIA month format
        yearFormat: '%Y', // ARIA year format
        hourFormat: 'Saat: %G', // ARIA hour format
        minuteFormat: 'Dakika: %i', // ARIA minute format
        removeItem: 'Öğeyi kaldır', // ARIA label for removing item
        pages: ['İlk sayfa', 'Önceki sayfa', 'Sonraki sayfa', 'Son sayfa'], // ARIA labels for pages
        page: 'Sayfa', // ARIA label for page
        headermenu: 'Başlık menüsü', // ARIA label for header menu
        openGroup: 'Sütun grubunu aç', // ARIA label for opening column group
        closeGroup: 'Sütun grubunu kapat', // ARIA label for closing column group
        closeTab: 'Sekmeyi kapat', // ARIA label for closing tab
        showTabs: 'Daha fazla sekme göster', // ARIA label for showing more tabs
        resetTreeMap: 'Orijinal görünüme dön', // ARIA label for resetting tree map
        navTreeMap: 'Aynı seviyeye yükselt', // ARIA label for navigating tree map
        nextTab: 'Sonraki sekme', // ARIA label for next tab
        prevTab: 'Önceki sekme', // ARIA label for previous tab
        multitextSection: 'Öğe ekle', // ARIA label for adding element
        multitextextraSection: 'Öğeyi kaldır', // ARIA label for removing element
        showChart: 'Grafiği göster', // ARIA label for showing chart
        hideChart: 'Grafiği gizle', // ARIA label for hiding chart
        resizeChart: 'Grafiğin boyutunu değiştir', // ARIA label for resizing chart
    },
    richtext: {
        underline: 'Altı çizili', // Label for underline
        bold: 'Kalın', // Label for bold
        italic: 'İtalik', // Label for italic
    },
    combo: {
        select: 'Seç', // Label for select
        selectAll: 'Tümünü seç', // Label for select all
        unselectAll: 'Tümünü kaldır', // Label for unselect all
    },
};

// FILE DOCUMENTED
